import { ChevronDown } from 'lucide-react';

import {
  Button,
  ButtonProps,
  IconButton,
  Menu,
  MenuButton,
  useIsMobile,
} from '@dotfile/frontend/shared/design-system';

import { useCurrentContactEmail } from '../../hooks';
import { CaseMenuList } from './case-menu-list';

export type CaseMenuButtonProps = Omit<ButtonProps, 'aria-label' | 'children'>;

export const CaseMenu = ({ ...props }: CaseMenuButtonProps) => {
  const isMobile = useIsMobile();
  const { email, loading } = useCurrentContactEmail();

  if (loading) {
    return null;
  }

  return (
    <Menu>
      {isMobile ? (
        <MenuButton
          as={IconButton}
          aria-label="Onboarding menu"
          icon={<ChevronDown />}
          {...props}
        />
      ) : (
        <MenuButton
          as={Button}
          aria-label="Onboarding menu"
          rightIcon={<ChevronDown />}
          {...props}
        >
          {email}
        </MenuButton>
      )}
      <CaseMenuList />
    </Menu>
  );
};
